import React from "react";
import styled from "styled-components";
import image1 from "../../../assets/speakers-img/Dr-Peter-Ngene.jpg"
import image2 from '../../../assets/speakers-img/Prof Sossina Haile.jpg'
import image3 from "../../../assets/speakers-img/Prof Ange Nzihou.jf.jpg"
import image4 from "../../../assets/speakers-img/Prof wole Soboyejo.jpg"
import image5 from "../../../assets/speakers-img/P-Scardi.jpg"
import image6 from "../../../assets/speakers-img/Prof Rudolf.png"
import image7 from "../../../assets/speakers-img/Prof Maaza.jpg"
import image8 from "../../../assets/speakers-img/Prof Suprakas Singh.jpg"
import image9 from "../../../assets/speakers-img/Prof Sanjay.jpg"



const IUMRSspeakers = () => {
    const speakers = [
        {
          id: 1,
          name: 'Prof. Suprakas Sinha Ray ',
          affiliation: 'CSIR CeNAM, South Africa',
          image: image8
          },
        {
          id: 2,
          name: 'Prof. Sossina Haile',
          affiliation: 'Northwestern University, Illinois',
          image: image2
        },
        {
          id: 3,
          name: 'Prof. Wole Soboyejo',
          affiliation: 'SUNY Poltechnic University, New York',
          image: image4
        },
        {
          id: 4,
          name: 'Prof. Ange Nzihou',
          affiliation: 'IMT Mines, Albi, France',
          image: image3
        },
        {
          id: 5,
          name: 'Prof. Paolo Scardi',
          affiliation: 'University of Trento, Italy',
          image: image5
        },
        {
          id: 6,
          name: 'Prof. Petra Rudolf',
          affiliation: 'University of Groningen, Netherlands',
          image: image6
        },
        {
          id: 7,
          name: 'Dr. Peter Ngene',
          affiliation: 'Utrecht University, Netherlands',
          image: image1
        }/*,
        {
          id: 8,
          name: 'Prof. Malik Maaza',
          affiliation: 'University of South Africa',
          image: image7
          },
        
        {
          id: 9,
          name: 'Prof. Sanjay Mathur',
          affiliation: 'University of Cologne, Germany',
          image: image9
          }
          */
      ];
    
      return (
        <Container>
          <HeaderContainer>
            <HeaderDivider>
              <div className="line"></div>
              <div className="diamond">
                <svg viewBox="0 0 24 24" width="50" height="50">
                  <path fill="currentColor" d="M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56C4.61 15.07 4 16.1 4 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm10 7.8L19.6 22 17 19.4l1.4-1.4 1.6 1.6 3.6-3.6L25 17.4l-3 3.4z" />
                </svg>
              </div>
              <div className="line"></div>
            </HeaderDivider>
            <Title>Meet Our Plenary Speakers</Title>
          </HeaderContainer>
    
          <SpeakersRow>
            {speakers.slice(0, 9).map((speaker) => (
              <SpeakerCard key={speaker.id}>
                <img className="profile" src={speaker.image} alt={speaker.name} 
                />
                <div className="info">
                  <div className="name">{speaker.name}</div>
                  <div className="affiliation">{speaker.affiliation}</div>
                </div>
              </SpeakerCard>
            ))}
          </SpeakersRow>
        </Container>
      );
    };

const Container = styled.section`
  width: 80%;
  max-width: 1200px;
  margin: 8em auto;
  padding: 3rem 1rem;

  @media (min-width: 920px) {
    width: 100%;
    margin: 0 auto;
  }
`;

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const HeaderDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .line {
    height: 1px;
    background-color: #d1d5db;
    width: 3rem;
  }

  .diamond {
    margin: 0 1rem;
    color: #3b82f6;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #1f2937;
`;

const SpeakersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  justify-items: center;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 920px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const SpeakerCard = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 15rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  .profile {
    width: 100%;
    height: 17rem;
    object-fit: cover;
    object-position: center;
  }

  .info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #082D4A;
    padding: 0.5rem;
    color: var(--color-white);
  }

  .name {
    font-weight: 500;
    font-size: 1.1rem;
    padding-bottom: .75rem;
  }

  .affiliation {
    font-size: 0.875rem;
  }
`;

export default IUMRSspeakers;